import Heading from "../ui/Heading";
import MediaWrap from "../ui/MediaWrap";

export default function ContentBlock({ params }) {
  const { media, contentBlock } = params;
  return (
    <div
      className={`
            ob-content-block 
            ${contentBlock.withPadding === true ? "ob-with-padding" : ""} 
            ${contentBlock.colored === true ? "ob-colored" : ""} 
            ${contentBlock.background ? contentBlock.background : ""}
            `}
    >
      <div className="ob-columnar">
        <MediaWrap params={media} />
        <Heading params={contentBlock} />
      </div>
    </div>
  );
}
